import React from 'react';
import "../assets/css/Promoter.css";
import "../assets/css/Mission.css";

const AboutPromoters = () => {
  return (
    <div className='mato_missions'>
        <h1>About Promoters</h1>
    
      <div className='mission_content_wrappers'>
        <div className='mission_contents'>
            {/* <div className='mission_content2'>
                <h2>G Suresh:</h2>
                <p>A Mechanical Diploma Engineer with 25 years of experience in reputed auto-
            component manufacturing industries. Possesses vast knowledge and expertise
            in manufacturing, research and development of auto-components, as well as in
            the service and maintenance of all conventional and CNC machines.</p>
            </div> */}
            <div className='mission_dividers'></div>
            <div className='mission_content2'>
                <h2>Prashanth E N:</h2>
                <p>Prashanth E N, a proficient Mechanical Engineering graduate, has successfully led ventures in land development and diverse sectors. He now leverages his strategic acumen as a Purchase Officer at Tata Magna Seating Pvt. Ltd., Chinchwad, Pimpri, Pune.</p>
            </div>
            <div className='mission_dividers'></div>
            {/* <div className='mission_content2'>
                <h2>Prashanth N J:</h2>
                <p>He is a graduate of architecture and has developed many successful
                businesses like mining, Trading & Real estate.</p>
            </div> */}
        </div>
        </div>
    </div>
  )
}

export default AboutPromoters
